import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import Checkbox from '../Checkbox';

const CheckboxField = ({ input, ...rest }: FieldRenderProps<boolean>) => (
  <Checkbox {...input} {...rest} />
);

export default CheckboxField;
